/*
  Akordeon navigace v mobilním drawer menu — replika chování therabody.eu
  Zdroj: therabody.eu/cdn/shop/t/7/assets/custom-header-drawer.js
  (přepsáno do čitelné podoby, bez dataLayer závislosti)
*/

/*
  Rozbalení / sbalení s animací na skutečnou výšku obsahu.
  CSS (tb-header-drawer.css) má otevřený stav max-height: none a zavřený 0,
  tady se jen na dobu animace nastaví výška v px, ať se dá plynule animovat.
*/
const TB_COLLAPSIBLE = '.menu-item-submenu, .menu-item-submenu-links';

function tbAnimateCollapse(element, open) {
  if (!element.matches(TB_COLLAPSIBLE)) {
    element.classList.toggle('collapse--active', open);
    return;
  }

  clearTimeout(element._tbCollapseTimer);

  if (open) {
    /* Inline 0 před přidáním třídy, jinak by se při čtení scrollHeight
       prvek na okamžik roztáhl (max-height: none se neanimuje) */
    element.style.maxHeight = '0px';
    element.classList.add('collapse--active');
    /* +24 px rezerva: padding-bottom otevřeného stavu se animuje souběžně
       a scrollHeight ho v tuhle chvíli ještě nezahrnuje */
    element.style.maxHeight = element.scrollHeight + 24 + 'px';
  } else {
    element.style.maxHeight = element.scrollHeight + 'px';
    element.offsetHeight; /* reflow: animace musí začít z aktuální výšky */
    element.classList.remove('collapse--active');
    element.style.maxHeight = '0px';
  }

  /* Po animaci vrátit řízení CSS (otevřeno = none, zavřeno = 0) */
  const duration = parseFloat(getComputedStyle(element).getPropertyValue('--tb-acc-dur')) * 1000 || 0;
  element._tbCollapseTimer = setTimeout(() => {
    element.style.maxHeight = '';
  }, duration + 50);
}

function tbToggleCollapse(button, selectors) {
  const open = !button.classList.contains('btn-collapse--active');
  button.classList.toggle('btn-collapse--active', open);
  button.setAttribute('aria-expanded', String(open));

  selectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      /* aria-hidden jen na rozbalovaný obsah; <li> se sloupcem obsahuje i samotné
         tlačítko, to musí zůstat pro čtečku viditelné */
      if (element.matches(TB_COLLAPSIBLE)) element.setAttribute('aria-hidden', open ? 'false' : 'true');
      tbAnimateCollapse(element, open);
    });
  });
}

/* Zpětná kompatibilita pro případné starší onclick atributy */
function handleCollapseButton(event, title, ...selectors) {
  const button = event.target.closest('button');
  if (button) tbToggleCollapse(button, selectors);
}

document.addEventListener('DOMContentLoaded', function () {
  const isVisible = (el) => {
    const style = window.getComputedStyle(el);
    return style.opacity !== '0' && style.display !== 'none' && style.visibility !== 'hidden';
  };

  /* Kliknutí kamkoli do řádku 1. úrovně rozbalí sekci (odkaz se deaktivuje) */
  document.querySelectorAll('.menu-drawer__menu > li').forEach((li) => {
    const button = li.querySelector('.btn-collapse');
    const wrapper = li.querySelector('.menu-item-link');
    const link = li.querySelector('a.link');
    if (!wrapper) return;

    if (button && link && isVisible(button)) {
      link.removeAttribute('href');
      link.style.pointerEvents = 'none';
      link.style.cursor = 'default';
    }

    wrapper.addEventListener('click', function (event) {
      if (!button || button.contains(event.target)) return;
      if (!isVisible(button)) return;
      event.preventDefault();
      button.click();
    });
  });

  /* Totéž pro hlavičky sloupců uvnitř sekce */
  document.querySelectorAll('.menu-item-submenu-list').forEach((submenuLi) => {
    const button = submenuLi.querySelector('.btn-collapse');
    const header = submenuLi.querySelector('.menu-item-submenu-header');
    if (!button || !header) return;

    const link = header.querySelector('a.link');
    if (link && isVisible(button)) {
      link.removeAttribute('href');
      link.style.pointerEvents = 'none';
      link.style.cursor = 'default';
    }

    header.addEventListener('click', function (event) {
      if (button.contains(event.target)) return;
      button.click();
      event.stopPropagation();
    });
  });

  document.querySelectorAll('.btn-collapse').forEach((btn) => {
    btn.addEventListener('click', (e) => e.stopPropagation());
  });

  /* Tlačítka s data-tb-collapse="#a, #b" (náhrada inline onclick) */
  document.querySelectorAll('.btn-collapse[data-tb-collapse]').forEach((btn) => {
    const selectors = btn.dataset.tbCollapse.split(',').map((s) => s.trim()).filter(Boolean);
    btn.addEventListener('click', () => tbToggleCollapse(btn, selectors));
  });

  initTileTitleEqualHeights();
});

/*
  Na tabletu jsou dlaždice v drawer menu v mřížce — titulky různé délky
  by rozhodily spodní hranu. Dorovnáváme min-height po řádcích.
*/
function initTileTitleEqualHeights() {
  const TABLET_MQ = '(min-width: 768px) and (max-width: 1199px)';
  const SECTION_IDS = ['drawer-explore'];
  const DRAWER_SELECTOR = '#menu-drawer';

  const debounce = (fn, ms) => {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), ms);
    };
  };

  const getSectionRoot = (id) => {
    const drawer = document.querySelector(DRAWER_SELECTOR);
    return drawer ? drawer.querySelector(`#${CSS.escape(id)}`) : null;
  };

  const getColumnCount = (ul) => {
    const raw = window.getComputedStyle(ul).gridTemplateColumns;
    if (!raw || raw === 'none') return 2;
    const repeat = raw.match(/repeat\s*\(\s*(\d+)/i);
    if (repeat) {
      const n = parseInt(repeat[1], 10);
      return Number.isFinite(n) && n > 0 ? n : 2;
    }
    const parts = raw.split(/\s+/).filter(Boolean);
    return parts.length > 0 ? parts.length : 2;
  };

  const equalize = (root) => {
    if (!root) return;
    root.querySelectorAll('.menu-item-submenu-list-title').forEach((el) => {
      el.style.minHeight = '';
    });
    if (!window.matchMedia(TABLET_MQ).matches) return;
    if (!root.classList.contains('collapse--active')) return;

    const ul = root.querySelector('.menu-item-submenu-nav');
    if (!ul) return;

    const titles = [...ul.querySelectorAll(':scope > .menu-item-submenu-list')].map((li) =>
      li.querySelector('.menu-item-submenu-list-title')
    );
    if (titles.some((t) => !t)) return;

    const colCount = getColumnCount(ul);
    const rowCount = Math.ceil(titles.length / colCount);

    for (let row = 0; row < rowCount; row++) {
      const slice = [];
      for (let col = 0; col < colCount; col++) {
        const i = row * colCount + col;
        if (i < titles.length) slice.push(titles[i]);
      }
      if (slice.length < 2) continue;

      let maxH = 0;
      for (const el of slice) maxH = Math.max(maxH, el.getBoundingClientRect().height);
      const px = `${Math.ceil(maxH)}px`;
      for (const el of slice) el.style.minHeight = px;
    }
  };

  const runAll = () => SECTION_IDS.forEach((id) => equalize(getSectionRoot(id)));
  const debouncedRun = debounce(runAll, 120);
  const runAfterTransition = () => window.setTimeout(runAll, 350);

  for (const id of SECTION_IDS) {
    const root = getSectionRoot(id);
    if (!root) continue;
    new MutationObserver(() => {
      debouncedRun();
      if (root.classList.contains('collapse--active')) runAfterTransition();
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }

  window.addEventListener('resize', debouncedRun);

  const drawerDetails = document.getElementById('Details-menu-drawer-container');
  if (drawerDetails) {
    drawerDetails.addEventListener('toggle', () => {
      debouncedRun();
      if (drawerDetails.open) runAfterTransition();
    });
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(debouncedRun).catch(() => {});
  requestAnimationFrame(() => requestAnimationFrame(debouncedRun));
}
